module.exports = __webpack_public_path__ + "img/pexels-cottonbro-7579831.0479f41f.jpg";